import moment from 'moment';
import { useSelector } from 'react-redux';
import { SHORT_DATE_FORMAT } from 'common/constants/constants';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import {
  dateRangeSelector,
  selectedPeriodKeySelector
} from 'state/selectors/ui-state';
import {
  LBTrophyIcon,
  LBTooltipProvider,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent,
  LBBenchmarkIndication
} from '@linearb/buzz';

const TopReviewer = ({ reviews, isBurnout, isWipOverload, name }) => {
  const showTopReviewerText = !isBurnout && !isWipOverload;
  const selectedPeriodKey = useSelector(selectedPeriodKeySelector);
  const dateRange = useSelector(dateRangeSelector);
  const { from, to } = dateRange;
  const customDatesFormattedText = `for ${moment(from).format(
    SHORT_DATE_FORMAT
  )} - ${moment(to).format(SHORT_DATE_FORMAT)}`;

  const selectedPeriodText =
    selectedPeriodKey === PERIODS.CUSTOM.periodKey
      ? customDatesFormattedText
      : PERIODS[selectedPeriodKey]?.topReviewerText;

  return (
    <>
      {showTopReviewerText && (
        <div className='pr-2 text-sm' data-testid='top-reviewer-text'>
          {reviews} reviews
        </div>
      )}
      <LBTooltipProvider key={name}>
        <LBTooltip>
          <LBTooltipTrigger className='overflow-hidden text-ellipsis'>
            <LBBenchmarkIndication variant='elite' size='sm'>
              <LBTrophyIcon />
            </LBBenchmarkIndication>
          </LBTooltipTrigger>
          <LBTooltipContent>
            {name} is the top reviewer with {reviews} reviews{' '}
            {selectedPeriodText}.
          </LBTooltipContent>
        </LBTooltip>
      </LBTooltipProvider>
    </>
  );
};

export default TopReviewer;
